module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4t0Oqq/tc-custom/9781454927839.jpg?1736478804119",
      "alt": "This image is the cover for the book Quotes for Nasty Women"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Quotes for Nasty Women\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A compendium of inspiring, witty, and nasty quotations by and about powerful women through history.")]), _c('br'), _c('br'), _vm._v(" When Donald Trump referred to Hillary Clinton as “such a nasty woman” during a presidential debate in 2016, women everywhere—whatever their politics or feelings about Clinton—felt a jolt of recognition. In response, they promptly turned his insult into an empowering slogan. This book celebrates women’s power and resilience with quotes that demonstrate what it means to be "), _c('i', [_vm._v("nasty")]), _vm._v("."), _c('br'), _c('br'), _vm._v(" The book includes entries from women of the ancient world like Cleopatra; freedom fighters like Harriet Tubman; founding mothers like Mary Wollstonecraft and Elizabeth Cady Stanton; and feminist icons such as Gloria Steinem and Betty Friedan. It also features the words of politicians and government leaders; groundbreakers in arts and culture; celebrities; and the mothers, daughters, and sisters at home. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Linda Picone\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Linda Picone is a writer and editor. Her books include Carpe Diem: Quotes to Seize the Day (Fall River Press) and The Daily Book of Positive Quotations (Fairview Press).")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0